export const nameReducer = 'authManager';
